/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import * as Yup from "yup";
import PrimaryButton from '../../../../Forms/PrimaryButton';

const route = 'resources/content/admin/redirects';
const basePath = '/content-feature/redirects';

const rootCss = css`
    max-width: 100%;

    .form-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        .save-btn-container {
            display: flex;
            margin-top: 100px !important;
        }
    }
`;

const validationSchema = Yup.object({
    redirectId: Yup.number().required("Redirect Id is required"),
    oldUrl: Yup.string()
        .required("Old url is required")
        .max(1000, "Old url cannot exceed 1000 characters"),
    newUrl: Yup.string()
        .required("New url is required")
        .max(1000, "New url cannot exceed 1000 characters"),
    onOldSite: Yup.boolean().required("This field is required"),
});

function mapInitialValues(data) {
    return data && Object.keys(data).length 
            ? { ...data } 
            : { redirectId: 0, oldUrl: "", newUrl: "", onOldSite: false };
}

const successMsg = "Redirects Updated.";

const setErrorMsg = (show, errors) => (
    show && Object.keys(errors).length > 0
        ? `Errors in: ${Object.keys(errors).join(', ')}. Check all required * fields.`
        : "Errors in form, check all required fields and try again."
);

const basicInfoFields = [
    { name: "oldUrl", label: "Old Url", required: true },
    { name: "newUrl", label: "New Url", required: true },
];

const onOldSiteOptions = [
    { key: true, text: "True" },
    { key: false, text: "False" },
  ];

const unsavedMsg = 'You have unsaved changes, are you sure you want to leave?';

const SaveButton = ({ handleSave, dirty, submitting }) => {
    return (
        <div className="save-btn-container">
            <PrimaryButton
                onClick={handleSave}
                text="Save"
                disabled={!dirty || submitting}
            />
        </div>
    );
};


export {
    route,
    basePath,
    rootCss,
    validationSchema,
    mapInitialValues,
    successMsg,
    setErrorMsg,
    basicInfoFields,
    onOldSiteOptions,
    unsavedMsg,
    SaveButton,
};
